module.exports = __webpack_public_path__ + "static/media/website.50d70b6d.svg";